// ============= Imports =============
import React from 'react';
import { Input } from '@tw/tw-component-library';
import styled from 'styled-components';
import type { VisualPromptTextStepProps } from './types';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: 600;
`;

const TextArea = styled.textarea`
  width: 100%;
  min-height: 160px;
  padding: 0.75rem;
  border: 1px solid ${({ theme }) => theme.colors?.border?.light || '#e5e7eb'};
  border-radius: 8px;
  font-family: inherit;
  font-size: 0.9375rem;
`;

const ErrorText = styled.p`
  color: #b71c1c;
  font-size: 0.875rem;
`;

// ============= Component =============
export const VisualPromptTextStep: React.FC<VisualPromptTextStepProps> = ({
  step,
  answers,
  onAnswer,
  error,
}) => {
  const value = String(answers[step.mapsTo] ?? '');

  return (
    <Container>
      <Title>{step.title}</Title>
      {step.description && <p>{step.description}</p>}
      {step.type === 'textarea' ? (
        <TextArea
          value={value}
          placeholder={step.placeholder}
          onChange={(e) => onAnswer(step.mapsTo, e.target.value)}
        />
      ) : (
        <Input
          value={value}
          placeholder={step.placeholder}
          onChange={(e) => onAnswer(step.mapsTo, e.target.value)}
        />
      )}
      {error && <ErrorText>{error}</ErrorText>}
    </Container>
  );
};
